import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row row-cols-1 row-cols-md-2 row-cols-xl-3 g-2 g-xl-3" }
const _hoisted_2 = { class: "ol-md-4" }
const _hoisted_3 = { class: "card h-md-100" }
const _hoisted_4 = { class: "card-body d-flex flex-column flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RoleCard = _resolveComponent("RoleCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "card-title m-15" }, [
          _createElementVNode("h2", { class: "text-center" }, "Ajouter un rôle")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createTextVNode(" . ")),
          _cache[2] || (_cache[2] = _createElementVNode("i", {
            class: "flaticon-form",
            style: {"font-size":"140px","text-align":"center"}
          }, null, -1)),
          _createVNode(_component_router_link, {
            to: { name: 'AddRolePage' },
            class: "btn btn-primary btn-active-primary"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("span", { class: "fw-bolder" }, [
                _createElementVNode("i", { class: "plus" }),
                _createTextVNode("Ajouter un rôle")
              ], -1)
            ])),
            _: 1
          })
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleDatas, (role, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-md-4",
        key: index
      }, [
        _createVNode(_component_RoleCard, {
          id: role.id,
          nom: role.description,
          number: role.rolePermissions?.length,
          privileges: role.rolePermissions,
          onDelete: ($event: any) => (_ctx.suppression(role.id,_ctx.roleDatas,'roles','role'))
        }, null, 8, ["id", "nom", "number", "privileges", "onDelete"])
      ]))
    }), 128))
  ]))
}